var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 13.75,
    r: 1.25,
    fill: "#C8C8C8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 13.75,
    r: 1.25,
    fill: "#C8C8C8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 13.75,
    r: 1.25,
    fill: "#C8C8C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.75V18.75C5 20.1307 6.11929 21.25 7.5 21.25H7.80321C8.32611 21.25 8.75 21.6739 8.75 22.1968C8.75 23.2276 8.83699 24.7525 9.86737 24.7236C10.5664 24.704 10.8163 23.8495 11.1964 23.2626L11.6723 22.5278C12.1884 21.731 13.0731 21.25 14.0224 21.25H21.5C23.433 21.25 25 19.6833 25 17.7503V9.74972C25 7.81672 23.4335 6.25 21.5005 6.25H8.49948C6.56648 6.25 5 7.817 5 9.75Z",
    stroke: "#C8C8C8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.e57ac6bc4edb158c02d125d8ae9f9f01.svg";
export { ForwardRef as ReactComponent };